import { MfeConfig } from '../../types/mfe';
import aacTemplate from './aac-template';
import agent from './agent';
import apiMarketplace from './api-marketplace';
import apiMarketplaceStagingForProd from './api-marketplace-staging-for-prod';
import appMarketplace from './app-marketplace';
import cioMentorship from './cio-mentorship';
import dashboardLibrary from './dashboard-library';
import multiLanguageTranslation from './multi-language-translation';
import { docList, docViewer, contribute } from './docs-viewer';
import eapOnboard from './eap-onboard';
import embargoes from './embargoes';
import example from './example';
import externalHealthCheck from './external-health-check';
import haproxyFrontDoor from './haproxy-front-door';
import f5FrontDoor from './f5-front-door';
import homepage from './homepage';
import icc from './icc';
import mfeLite from './mfe-lite';
import { sidenav } from './navigation';
import securityMetrics from './security-metrics';
import sroPortal from './sro-portal';
import tasc from './tasc';
import translationsTool from './translations-tool';
import { videoLibrary } from './video-library';
import wask from './wask';
import analytics from './analytics';
import githubIngestionTracker from './github-ingestion-tracker';
import aacLanding from './aac-landing';
import ccoeAdminPortal from './ccoe-admin-portal';
import ccoeAwsManagement from './ccoe-aws-management';
import ccoeBackendCore from './ccoe-backend-core';
import ccoeBillingChargeManagement from './ccoe-billing-charge-management';
import ccoeCommon from './ccoe-common';
import ccoeCostOptimization from './ccoe-cost-optimization';
import ccoeGroupsManagement from './ccoe-groups-management';
import ccoeNamespaceGenerator from './ccoe-namespace-generator';
import ccoeOnboardPlugin from './ccoe-onboard-plugin';
import ccoeServiceAccountKey from './ccoe-service-account-key';
import ccoeSlotReservation from './ccoe-slot-reservation';
import metadataSearchTool from './metadata-search-tool';
import releases from './releases';
import turbopufferExplorer from './turbopuffer-explorer';
import apiKeyManager from './api-key-manager';
import mcpSetup from './mcp-setup';
import profile from './profile';
import scaffolder from './scaffolder';

export const components: MfeConfig[] = [
  aacLanding,
  aacTemplate,
  agent,
  apiMarketplace,
  apiMarketplaceStagingForProd,
  appMarketplace,
  ccoeAdminPortal,
  ccoeAwsManagement,
  ccoeBackendCore,
  ccoeBillingChargeManagement,
  ccoeCommon,
  ccoeCostOptimization,
  ccoeGroupsManagement,
  ccoeNamespaceGenerator,
  ccoeOnboardPlugin,
  ccoeServiceAccountKey,
  ccoeSlotReservation,
  cioMentorship,
  dashboardLibrary,
  docList,
  docViewer,
  contribute,
  eapOnboard,
  embargoes,
  example,
  externalHealthCheck,
  f5FrontDoor,
  haproxyFrontDoor,
  homepage,
  icc,
  metadataSearchTool,
  mfeLite,
  multiLanguageTranslation,
  releases,
  securityMetrics,
  sidenav,
  sroPortal,
  tasc,
  translationsTool,
  turbopufferExplorer,
  videoLibrary,
  wask,
  analytics,
  githubIngestionTracker,
  apiKeyManager,
  mcpSetup,
  profile,
  scaffolder,
];
